import { Utils } from '../../../../providers/utils';
import { RecipeDetailPageFull } from '../recipe-detail/recipe-detail.full';
import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
import { RecipeData } from '../../providers/recipe-data';
import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
// import { RecipeDetailPage } from '../../pages/recipe-detail/recipe-detail';
import { RecipeBoxesCommon } from './recipe-boxes.common';

@Component({
	selector: 'recipe-boxes-full',
	templateUrl: 'recipe-boxes.full.html'
})
export class RecipeBoxesPageFull extends PageBaseFull {
	categoryId = '';
	category: any;
	userId = '';
	public recipeBoxData: any;
	public recipesList: any;
	public recipeCategories: any;
	public loader: any;
	public userRecipes = [];
	// public localUserRecipes = [];
	public pageSize: number = 2;

	public categoryUrlSlug = 'all';

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: RecipeBoxesCommon,
		public loadingCtrl: LoadingController,
		public recipeData: RecipeData,
		public recipeBoxGateway: RecipeBoxDataGateway,
		private navParams: NavParams,
	) {
		super(settings, events, nav, userData);
		this.categoryUrlSlug = navParams.get('categoryUrlSlug');
	}
	ngAfterViewInit() {
	}
	ionViewDidEnter() {
		this.loader = this.loadingCtrl.create();
		this.userId = this.currentUser ? this.currentUser.uid : null;
		this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
		this.loadData();
	}
	public loadData() {
		var self = this;
		this.loader.present();

		// this.loader.present();
		self.getAllCategoriesData().subscribe(categoriesRes => {
			// self.loader.dismiss();
			self.category = _.find(categoriesRes, (categoriesRe: any) => {
				return categoriesRe.urlSlug == self.categoryUrlSlug;
			});
			if (!this.category)
				this.category = { $key: 'All', name: 'All' };
			this.getUserRecipesData().subscribe(userRecipes => {
				_.forEach(this.recipeCategories, category => {
					if (category.$key) {
						let recipe = _.filter(userRecipes, (item: any) => {
							return _.find(item.categories, (itemCategory: any, key) => {
								return key == category.$key;
							});
						});
						if (recipe && recipe.length > 0) {
							category.totalRecipes = recipe.length;
						}
						else {
							category.totalRecipes = 0;
						}
					}
				});
				if (this.category.$key != 'All')
				{
					this.userRecipes = _.filter(this.userRecipes, userRecipe => {
						return _.find(userRecipe.categories, (itemCategory: any, key) => {
							return key == this.category.$key;
						});
					});
				}
				this.loader.dismiss();
			});
		});

	}

	public getUserRecipesData() {
		return this.recipeBoxData.getUserRecipes(this.userId).map(userRecipes => {
			console.log(userRecipes);
			userRecipes = Utils.toAngularFireArray(userRecipes).reverse();
			_.forEach(userRecipes, (userRecipe: any) => {
				userRecipe.isFavorite = true;
			});
			this.userRecipes = userRecipes;

			return userRecipes;
		});

	}
	public getAllCategoriesData() {
		return this.recipeData.getAllCategories().map(recipeCategories => {
			if (recipeCategories) {
				this.recipeCategories = recipeCategories;
			}
			return recipeCategories;
		});
	}
	addOrRemoveUserRecipe(recipe) {
		if (!recipe.isFavorite) {
			this.recipeBoxData.add(this.userId, recipe).then(userRecipe => {
				console.log(userRecipe);
				recipe.isFavorite = userRecipe.$key;
			});
		}
		else {
			this.recipeBoxData.remove(this.userId, recipe).then(result => {
				if (result)
					recipe.isFavorite = false;
			});
		}
	}

	//Recipe detail
	viewRecipeDetail(recipe) {
		console.log(recipe);
		this.nav.push(RecipeDetailPageFull, { categoryUrlSlug: this.categoryUrlSlug, id: recipe.$id ? recipe.$id : recipe.$key });
	}
	viewRecipeCategory(categoryUrlSlug) {
		if (!categoryUrlSlug)
			categoryUrlSlug = 'all';
		this.nav.push(RecipeBoxesPageFull, { categoryUrlSlug: categoryUrlSlug });
	}
}


// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-boxes/recipe-boxes.full.ts